import { api } from './api.js';

// The countries whose public holidays the API computes (date-holidays, about
// 200), as [{ value: 'CZ', label: 'Czech Republic' }] sorted by name. Fetched
// once per page load and shared by Team → Edit member and Reminders; a failed
// fetch is retried on the next call.
let pending = null;

export function loadHolidayCountries() {
  pending ??= api('/admin/holiday-countries')
    .then((result) => result.countries)
    .catch((err) => {
      pending = null;
      throw err;
    });
  return pending;
}

// Select options before the list has loaded: just the current value, so the
// field shows it instead of an empty trigger.
export function countryOptions(countries, current) {
  if (countries.some((country) => country.value === current)) return countries;
  return [{ value: current, label: current }, ...countries];
}
